import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  baseUrl = environment.baseUrl;

  color_form = new FormGroup({
    id: new FormControl(null),
    color_name: new FormControl('', [Validators.required]),
    color_code: new FormControl('', [Validators.required]),
  });

  constructor(private http: HttpClient,) { }

  populateForm(rowData: any) {
    this.color_form.setValue(_.omit(rowData, 'company_id', 'user_id',
      'status', 'created_at', 'updated_at', 'deleted_at'));
  }

  get_all_colors() {
    return this.http.get(this.baseUrl + '/get_all_colors');
  }

  insert_color(formData: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('color_name', formData.color_name);
    myFormData.append('color_code', formData.color_code);
    return this.http.post(this.baseUrl + '/create_color', myFormData, {
      headers: headers
    });
  }

  update_color(formData: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('color_name', formData.color_name);
    myFormData.append('color_code', formData.color_code);
    return this.http.post(this.baseUrl + '/update_color/' + formData.id, myFormData, {
      headers: headers
    });
  }

  update_color_status(id: any, status: any) {
    return this.http.get(this.baseUrl + '/update_color_status/' + id + '/'+ status);
  }

  delete_color(id: any) {
    return this.http.get(this.baseUrl + '/delete_color/' + id);
  }

}
